import React, { createContext, useContext } from 'react';
import { useLoadScript } from '@react-google-maps/api';

// Create context to share loading state across components
const GoogleMapsContext = createContext({
    isLoaded: false,
    loadError: null
});

// Custom hook to access Google Maps loading state
export const useGoogleMaps = () => {
    const context = useContext(GoogleMapsContext);
    if (!context) {
        throw new Error('useGoogleMaps must be used within GoogleMapsLoader');
    }
    return context;
};

// Libraries needed for the entire app
const libraries = ['places', 'marker'];

// Wrapper component that loads Google Maps once for entire app
export const GoogleMapsLoader = ({ children }) => {
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: libraries
    });

    return (
        <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
            {children}
        </GoogleMapsContext.Provider>
    );
};